(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-seo-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!window.pestanasSeoProductoIniciadas) {
    window.pestanasSeoProductoIniciadas = true;

    const activarPestanaSeoProducto = (pestana, enfocar) => {
      const seccion = pestana.closest('[data-product-seo-tabs]');
      const pestanas = Array.from(seccion.querySelectorAll('[data-product-seo-tab]'));
      const paneles = pestanas.map((elemento) => document.getElementById(elemento.getAttribute('aria-controls')));

      const actualizarPestana = () => {
        pestanas.forEach((elemento, indice) => {
          const estaActiva = elemento === pestana;
          elemento.classList.toggle('is-active', estaActiva);
          elemento.setAttribute('aria-selected', estaActiva.toString());
          elemento.tabIndex = estaActiva ? 0 : -1;
          paneles[indice].hidden = !estaActiva;
        });

        if (enfocar) pestana.focus();
      };

      if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        document.startViewTransition(actualizarPestana);
      } else {
        actualizarPestana();
      }
    };

    document.addEventListener('click', (evento) => {
      const pestana = evento.target.closest('[data-product-seo-tab]');
      if (pestana) activarPestanaSeoProducto(pestana, false);
    });

    document.addEventListener('keydown', (evento) => {
      const pestana = evento.target.closest('[data-product-seo-tab]');
      if (!pestana) return;

      const pestanas = Array.from(pestana.closest('[role="tablist"]').querySelectorAll('[data-product-seo-tab]'));
      const indiceActual = pestanas.indexOf(pestana);
      let indiceSiguiente = indiceActual;

      if (evento.key === 'ArrowRight') indiceSiguiente = (indiceActual + 1) % pestanas.length;
      if (evento.key === 'ArrowLeft') indiceSiguiente = (indiceActual - 1 + pestanas.length) % pestanas.length;
      if (evento.key === 'Home') indiceSiguiente = 0;
      if (evento.key === 'End') indiceSiguiente = pestanas.length - 1;
      if (indiceSiguiente === indiceActual) return;

      evento.preventDefault();
      activarPestanaSeoProducto(pestanas[indiceSiguiente], true);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
